
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.084.72c.939 0 1.648.325 2.128.976.48.65.72 1.51.72 2.576 0 .8-.128 1.595-.384 2.384-.363 1.163-1.013 2.23-1.952 3.2a8.526 8.526 0 01-3.216 2.096 6.31 6.31 0 01-2.192.4c-.608 0-1.152-.117-1.632-.352a3.376 3.376 0 01-1.568-1.472C.615 9.856.428 9.04.428 8.08c0-.341.005-.56.016-.656.128-1.11.443-2.096.944-2.96.768-1.355 1.893-2.48 3.376-3.376.288-.181.544-.299.768-.352h.08A.438.438 0 015.708.72c.17 0 .256.064.256.192a.377.377 0 01-.048.16c-.096.181-.299.363-.608.544a6.626 6.626 0 00-2.192 2.096 6.73 6.73 0 00-1.072 2.992c-.01.096-.016.315-.016.656 0 1.493.459 2.587 1.376 3.28.533.395 1.173.592 1.92.592.597 0 1.184-.139 1.76-.416.63-.31 1.21-.795 1.744-1.456a6.705 6.705 0 001.168-2.192 7.34 7.34 0 00.336-2.176c0-.95-.197-1.712-.592-2.288-.384-.587-.981-.88-1.792-.88-.224 0-.4.032-.528.096s-.283.187-.464.368c-.459.459-.853 1.083-1.184 1.872a1.66 1.66 0 01-.32.496c-.33.31-.672.475-1.024.496-.139 0-.235-.027-.288-.08-.043-.064-.01-.219.096-.464.33-.79.768-1.488 1.312-2.096.853-.981 1.856-1.568 3.008-1.76.213-.021.39-.032.528-.032z","fill":"currentColor"}})])
          )
        }
      }
    